export const getFileName = (url: string): string => {
  const decodedUrl = decodeURIComponent(url);
  const parts = decodedUrl.split('/');
  const fileWithUuId = parts[parts.length - 1];
  const fileNameParts = fileWithUuId.split('_');

  if (fileNameParts.length > 1) {
    return fileNameParts.slice(1).join('_');
  } else {
    return fileNameParts[1];
  }
};
